<script>
import { mapState } from 'vuex';
import escapable from '../../mixins/escapable';
import TwOverlay from '../TwOverlay';

export default {
  name: 'TriggerListsBookingMessages',
  mixins: [
    escapable,
  ],
  components: {
    TwOverlay,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      messages: state => state.triggers.lists.messages.messages,
      booking: state => state.triggers.lists.messages.booking,
    }),
  },
  methods: {
    close() {
      this.$emit('hide');
    },
    escapeHandler() {
      this.close();
    },
  },
};
</script>

<template>
  <v-dialog
    :value="visible"
    max-width="800px"
    persistent
    no-click-animation
  >
    <v-card v-if="booking">
      <v-card-title>
        <h3>Payment Remarks for [{{ booking.bookingRef }}]</h3>
        <v-spacer/>
        <v-btn class="ma-0" icon small><v-icon @click="close">close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text class="trigger-lists__booking-messages">
        <v-progress-circular v-if="messages.loading" class="trigger-lists__booking-messages-loading" indeterminate/>
        <tw-overlay :visible="messages.loading"/>
        <v-expansion-panel>
          <v-expansion-panel-content v-for="message in messages.items" :key="message.id">
            <template v-slot:header>
              <div>
                <span>{{ message.subject }}</span>
                <span class="caption grey--text">
                  ({{ message.createdBy.firstName }} {{ message.createdBy.lastName }})
                </span>
              </div>
            </template>
            <v-card>
              <v-divider/>
              <v-card-text
                v-if="!message.content"
                class="trigger-lists__booking-messages-no-content grey lighten-2 body-1 grey--text text--darken-1"
              >
                No content
              </v-card-text>
              <v-card-text v-else v-html="message.content" class="trigger-lists__booking-messages-content"/>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.trigger-lists__booking-messages {
  position: relative;
  min-height: 300px;

  &-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }

  &-content {
    min-height: 100px;
  }

  &-no-content {
    text-align: center;
    font-style: italic;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Triggers/TriggerListsBookingMessages.vue